export default {
    getUsersFromFetch({ fetch }) {
        return fetch.entities.map(({ user }) => user);
    },
};
